var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTarifasSparkles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 165,
    height: 115.955,
    viewBox: "0 0 165 115.955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkles",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.8,
    d: "M43.9829 29.6721C42.1611 29.6721 40.5996 28.2405 40.5996 26.2884C40.5996 24.3363 42.031 22.9048 43.9829 22.9048C45.8047 22.9048 47.3662 24.3363 47.3662 26.2884C47.3662 28.2405 45.8047 29.6721 43.9829 29.6721ZM43.9829 24.3363C42.8118 24.3363 41.9009 25.2473 41.9009 26.4186C41.9009 27.5898 42.8118 28.5008 43.9829 28.5008C45.154 28.5008 46.0649 27.5898 46.0649 26.4186C46.0649 25.2473 45.154 24.3363 43.9829 24.3363Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M160.315 90.1875C157.713 90.1875 155.631 87.9751 155.631 85.3723C155.631 82.7695 157.713 80.5571 160.315 80.5571C162.918 80.5571 165 82.7695 165 85.3723C165 87.9751 162.918 90.1875 160.315 90.1875ZM160.315 81.8585C158.364 81.8585 156.802 83.4202 156.802 85.3723C156.802 87.3244 158.364 88.8861 160.315 88.8861C162.267 88.8861 163.829 87.3244 163.829 85.3723C163.829 83.4202 162.267 81.8585 160.315 81.8585V81.8585Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.8,
    d: "M140.407 58.9538C138.715 58.9538 137.414 57.6523 137.414 55.9605C137.414 54.2687 138.715 52.9673 140.407 52.9673C142.099 52.9673 143.4 54.2687 143.4 55.9605C143.4 57.6523 142.099 58.9538 140.407 58.9538ZM140.407 54.2687C139.496 54.2687 138.715 55.0495 138.715 55.9605C138.715 56.8715 139.496 57.6523 140.407 57.6523C141.318 57.6523 142.099 56.8715 142.099 55.9605C142.099 55.0495 141.318 54.2687 140.407 54.2687Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.8,
    d: "M4.55468 64.0293C4.03418 64.0293 3.51367 63.6388 3.51367 62.9881V55.9606C3.51367 55.44 3.90405 54.9194 4.55468 54.9194C5.20531 54.9194 5.59569 55.3099 5.59569 55.9606V62.9881C5.59569 63.6388 5.07519 64.0293 4.55468 64.0293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.8,
    d: "M7.9377 60.5155H1.04101C0.520505 60.5155 0 60.1251 0 59.4743C0 58.8236 0.390379 58.4332 1.04101 58.4332H7.9377C8.4582 58.4332 8.97871 58.8236 8.97871 59.4743C8.97871 60.1251 8.58833 60.5155 7.9377 60.5155Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.8,
    d: "M29.4102 115.955C28.8896 115.955 28.3691 115.565 28.3691 114.914V107.886C28.3691 107.366 28.7595 106.845 29.4102 106.845C30.0608 106.845 30.4512 107.236 30.4512 107.886V114.914C30.4512 115.565 29.9307 115.955 29.4102 115.955Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.8,
    d: "M32.7932 112.441H25.8965C25.376 112.441 24.8555 112.051 24.8555 111.4C24.8555 110.749 25.2458 110.359 25.8965 110.359H32.7932C33.3137 110.359 33.8342 110.749 33.8342 111.4C33.8342 112.051 33.4438 112.441 32.7932 112.441Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.8,
    d: "M23.6819 7.15773C23.2915 7.15773 23.0312 6.89745 23.0312 6.50703V0.650703C23.0312 0.260281 23.2915 0 23.6819 0C24.0723 0 24.3325 0.260281 24.3325 0.650703V6.50703C24.3325 6.89745 23.9421 7.15773 23.6819 7.15773Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.8,
    d: "M26.416 4.1645H20.8206C20.4302 4.1645 20.1699 3.90422 20.1699 3.5138C20.1699 3.12337 20.4302 2.86309 20.8206 2.86309H26.416C26.8064 2.86309 27.0666 3.12337 27.0666 3.5138C27.0666 3.90422 26.8064 4.1645 26.416 4.1645Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.8,
    d: "M143.139 110.359C142.749 110.359 142.489 110.099 142.489 109.709V103.852C142.489 103.462 142.749 103.202 143.139 103.202C143.53 103.202 143.79 103.462 143.79 103.852V109.709C143.79 110.099 143.53 110.359 143.139 110.359Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.8,
    d: "M146.002 107.496H140.406C140.016 107.496 139.756 107.236 139.756 106.846C139.756 106.455 140.016 106.195 140.406 106.195H146.002C146.392 106.195 146.653 106.455 146.653 106.846C146.653 107.236 146.392 107.496 146.002 107.496Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.8,
    d: "M140.405 17.8292C139.624 17.8292 139.104 17.3086 139.104 16.5278V6.50697C139.104 5.72613 139.624 5.20557 140.405 5.20557C141.186 5.20557 141.706 5.72613 141.706 6.50697V16.5278C141.706 17.1785 141.056 17.8292 140.405 17.8292Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.8,
    d: "M145.22 12.7537H135.59C134.81 12.7537 134.289 12.2332 134.289 11.4523C134.289 10.6715 134.81 10.1509 135.59 10.1509H145.22C146 10.1509 146.521 10.6715 146.521 11.4523C146.521 12.2332 146 12.7537 145.22 12.7537Z",
    fill: "#CCCCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTarifasSparkles);
export default __webpack_public_path__ + "static/media/empty-tarifas-sparkles.337be78945810cda3024e9a341eb6ff2.svg";
export { ForwardRef as ReactComponent };